import React from 'react';
import _toInteger from 'lodash/toInteger';
import { Link } from 'react-router-dom';
import { defineMessages, useIntl } from '@kyruus/intl';
import { Pagination as BiomePagination } from '@biome-design-system/ui/Pagination';
import { PaginationItem } from '@biome-design-system/ui/PaginationItem';

const messages = defineMessages({
  gotoPreviousPage: {
    id: 'aria.label.gotoPreviousPage',
    description: 'Accessibility label for navigating to previous page',
    defaultMessage: 'Go to previous page'
  },
  gotoNextPage: {
    id: 'aria.label.gotoNextPage',
    description: 'Accessibility label for navigating to next page',
    defaultMessage: 'Go to next page'
  },
  gotoPage: {
    id: 'aria.label.gotopage',
    description: 'Accessibility label for navigating to a page',
    defaultMessage: 'Go to page {page}'
  },
  paginationControls: {
    id: 'aria.label.paginationControls',
    description: 'Accessibility label navigation container',
    defaultMessage: 'Results Page'
  }
});

export const Pagination = ({
  searchSummary,
  totalPages,
  getUpdatedSearch,
  log
}) => {
  const intl = useIntl();
  const currentPage = _toInteger(searchSummary.page) || 1;
  const onPaginate = (_event, page) =>
    log('user_action.search_results.page_results', {
      page_num: page,
      button_clicked: page,
      total_pages: totalPages
    });
  const getItemAriaLabel = (type, page) => {
    switch (type) {
      case 'page':
        return intl.formatMessage(messages.gotoPage, { page });
      case 'previous':
        return intl.formatMessage(messages.gotoPreviousPage);
      case 'next':
        return intl.formatMessage(messages.gotoNextPage);
      default:
        return undefined;
    }
  };

  return (
    <BiomePagination
      aria-label={intl.formatMessage(messages.paginationControls)}
      color="standard"
      count={totalPages}
      data-current-page={currentPage}
      data-total-pages={totalPages}
      data-view="paging"
      getItemAriaLabel={getItemAriaLabel}
      onChange={onPaginate}
      page={currentPage}
      renderItem={(item) => (
        <PaginationItem
          data-testid={`LinkToPage${item.page}`}
          component={Link}
          to={getUpdatedSearch([
            { action: 'append', key: 'page', value: item.page }
          ])}
          {...item}
        />
      )}
      shape="rounded"
      siblingCount={2}
    />
  );
};
